import script from "./SingleProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleProduct.vue?vue&type=script&setup=true&lang=js"

import "./SingleProduct.vue?vue&type=style&index=0&id=5fe5c2da&scoped=true&lang=css"
import "./SingleProduct.vue?vue&type=style&index=1&id=5fe5c2da&lang=css"

import exportComponent from "/var/www/levsha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fe5c2da"]])

export default __exports__